/**
 * @fileoverview Component for displaying a studies menu item.
 * This component includes a link to a specific route and displays an icon and title.
 */

import { useMatches } from 'react-router-dom'

import StudyIcon from '../../assets/menu/studies.svg'
import PlusIcon from '../../assets/plus.svg'
import { useModal } from '../../hooks/useModal'
import { NewParticipant } from '../modals/content/NewParticipant'
import { MenuItem } from './MenuItem'

/**
 * @function StudiesMenuItem
 * @description Component for displaying a studies menu item.
 * @returns {JSX.Element} - A React component that renders the studies menu item.
 */
export function StudiesMenuItem() {
    const [open] = useModal()
    const matches = useMatches()

    const fullUrl = matches[matches.length - 1].pathname

    // TODO: Remove false && when manual study creation is implemented
    const areStudiesSelected = false && Boolean(fullUrl.match(/\/app\/studies/))

    return (
        <>
            <div className="relative flex flex-col">
                <MenuItem
                    isActive={areStudiesSelected}
                    icon={StudyIcon}
                    title="Studies"
                    to="/app/studies"
                />

                {areStudiesSelected && (
                    <button
                        onClick={() => open({ content: <NewParticipant /> })}
                        className="absolute w-8 h-8 transition-all bg-indigo-100 hover:bg-indigo-200 flex justify-center items-center rounded-md p-1 right-2 top-2"
                    >
                        <PlusIcon className="w-5 h-5 fill-indigo-500" />
                    </button>
                )}
            </div>
        </>
    )
}
